import { Context, type Effect, Layer, type Scope } from "effect";
import type { json } from "monaco-editor";
import type { EditorLanguageFailure } from "./language-model.ts";
import type { EditorJsonRequest } from "./json-model.ts";

/** Native callback promises delegate only to the SDK, never to an Effect runner. */
export interface NativeJsonWorker extends json.IJSONWorker {
  doValidation(uri: string): Promise<unknown>;
  doComplete(uri: string, position: { line: number; character: number }): Promise<unknown>;
  doResolve(item: unknown): Promise<unknown>;
  doHover(uri: string, position: { line: number; character: number }): Promise<unknown>;
  format(uri: string, range: unknown, options: unknown): Promise<unknown>;
  resetSchema(uri: string): Promise<unknown>;
  findDocumentSymbols(uri: string): Promise<unknown>;
  findDocumentColors(uri: string): Promise<unknown>;
  getColorPresentations(uri: string, color: unknown, range: unknown): Promise<unknown>;
  getFoldingRanges(uri: string, context: unknown): Promise<unknown>;
  getSelectionRanges(uri: string, positions: unknown): Promise<unknown>;
}
export type NativeJsonWorkerAccess = (...resources: import("monaco-editor").Uri[]) => Promise<NativeJsonWorker>;
export interface EditorJsonSession {
  readonly languageId: string;
  readonly languageFor: (filename: string) => string | undefined;
}
export class EditorJsonIo extends Context.Service<EditorJsonIo, {
  readonly acquire: (request: EditorJsonRequest) => Effect.Effect<EditorJsonSession, EditorLanguageFailure, Scope.Scope>;
}>()("workerstation/frontend/EditorJsonIo") {}
export const EditorJsonIoTest = (ports: typeof EditorJsonIo.Service) => Layer.succeed(EditorJsonIo, ports);
